import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-argus',
  templateUrl: './argus.component.html',
  styleUrls: ['./argus.component.css']
})
export class ArgusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {


  }
}
